/**
 * Os critérios conferidos de uma saída, por expansão (E159.F3, ADR-0109 §2.7), na ordem do catálogo
 * e agrupados como ele: campos, afirmações e proteção. O estado e o detalhe vêm do servidor.
 */
import { ptBR } from '@/i18n/pt-BR';
import type { CriterioDaSaidaData, GrupoDoCriterio } from '@/lib/conferenciaDasSaidas';

const t = ptBR.conferenciaDasSaidas;
const GRUPOS: GrupoDoCriterio[] = ['campos', 'afirmacoes', 'protecao'];

function Criterio({ criterio }: { criterio: CriterioDaSaidaData }) {
  return (
    <li
      className="grid grid-cols-[minmax(0,14rem)_minmax(0,7rem)_1fr] gap-sc-2 py-1 text-caption"
      data-testid="criterio"
      data-chave={criterio.chave}
      data-estado={criterio.estado}
    >
      <span className="text-fg">
        {t.criterio[criterio.chave]}
        {criterio.bloqueante ? <span className="text-fg-muted"> · {t.bloqueante}</span> : null}
      </span>
      <span className="font-semibold text-fg">{t.estadoDoCriterio[criterio.estado]}</span>
      <span className="text-fg-muted">{criterio.detalhe}</span>
    </li>
  );
}

export function CriteriosConferidos({ criterios }: { criterios: CriterioDaSaidaData[] }) {
  return (
    <details className="mt-sc-3" data-testid="criterios-conferidos">
      <summary className="cursor-pointer text-body-sm text-accent-700">
        {t.criterios.replace('{total}', String(criterios.length))}
      </summary>
      {GRUPOS.map((grupo) => {
        const doGrupo = criterios.filter((c) => c.grupo === grupo);
        if (doGrupo.length === 0) return null;
        return (
          <section key={grupo} className="mt-sc-2">
            <h5 className="text-caption uppercase tracking-[0.08em] text-fg-muted">
              {t.grupo[grupo]}
            </h5>
            <ul>
              {doGrupo.map((c) => (
                <Criterio key={c.chave} criterio={c} />
              ))}
            </ul>
          </section>
        );
      })}
    </details>
  );
}
